import type { FlightTab } from "./tabs";

export type PilotScreen = "home" | "more" | FlightTab;

const ITEMS: { id: PilotScreen; label: string; aria: string }[] = [
  { id: "home", label: "Home", aria: "Home" },
  { id: "brief", label: "Brief", aria: "Brief" },
  { id: "duty", label: "Duty", aria: "Duty" },
  { id: "log", label: "Log", aria: "Log" },
  { id: "pax", label: "Pax", aria: "Pax" },
  { id: "checks", label: "Checklist", aria: "Checklist" },
  { id: "more", label: "More", aria: "More" },
];

function BarIcon({ id }: { id: PilotScreen }) {
  const common = {
    viewBox: "0 0 24 24",
    width: 20,
    height: 20,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    "aria-hidden": true,
  };
  if (id === "home") {
    return (
      <svg {...common}>
        <path d="M4 11.5 12 5l8 6.5" />
        <path d="M7 10.5V19h10v-8.5" />
      </svg>
    );
  }
  if (id === "brief") {
    return (
      <svg {...common}>
        <path d="M6 4.5h9l3 3V19.5H6z" />
        <path d="M15 4.5V8h3.5M8.5 12h7M8.5 15.5h5" />
      </svg>
    );
  }
  if (id === "duty") {
    return (
      <svg {...common}>
        <circle cx="12" cy="12" r="7.5" />
        <path d="M12 8.5V12l2.5 2" />
      </svg>
    );
  }
  if (id === "log") {
    return (
      <svg {...common}>
        <path d="M7 4.5h10v15H7z" />
        <path d="M9.5 8.5h5M9.5 12h5M9.5 15.5h3" />
      </svg>
    );
  }
  if (id === "pax") {
    return (
      <svg {...common}>
        <circle cx="9" cy="9" r="2.2" />
        <circle cx="15.5" cy="9.5" r="1.8" />
        <path d="M4.5 17.5c.6-2.2 2.4-3.3 4.5-3.3s3.9 1.1 4.5 3.3M13 14.4c1.2-.5 2.4-.4 3.6.2 1.1.6 1.8 1.6 2.2 2.9" />
      </svg>
    );
  }
  if (id === "checks") {
    return (
      <svg {...common}>
        <path d="M8 6.5h10v12H8z" />
        <path d="M6 9.5h2M6 13h2M10.5 10.5l1.2 1.2 2.3-2.4" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <circle cx="6" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <circle cx="18" cy="12" r="1.2" fill="currentColor" stroke="none" />
    </svg>
  );
}

/** Fixed phone and tablet navigation. Home stays available even with no assignment. */
export function PilotBar({ screen, onScreen }: { screen: PilotScreen; onScreen: (next: PilotScreen) => void }) {
  return (
    <nav className="pilot-bar" aria-label="Pilot" data-testid="pilot-bar">
      {ITEMS.map((item) => {
        const active = item.id === screen;
        return (
          <button
            key={item.id}
            type="button"
            className={active ? "pilot-tab is-active" : "pilot-tab"}
            aria-current={active ? "page" : undefined}
            aria-label={item.aria}
            data-testid={`pilot-tab-${item.id}`}
            onClick={() => onScreen(item.id)}
          >
            <BarIcon id={item.id} />
            <span className="pilot-tab-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
